import { config } from '../../config'
import axios from 'axios';

const state = {
    assistants: [],
};

const getters = {
    getAssistant: state => id => {
        return state.assistants.find(assistant => assistant.id === id);
    },
};

const actions = {

    //Fetch ALL
    async fetchAssistants({ commit }) {
        const response = await axios.get(config.serverUrl + 'study_department/assistant/basic');
        commit('setAssistants', response.data.items);
    },
};

const mutations = {
    setAssistants: ( state, assistants ) => (state.assistants = assistants),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
